import get from 'lodash/get'
import {
  isObject,
  isString,
  isNumberString,
  isEmptyString,
  isArray
} from 'lib/detectType'
import { getExtraFieldFromText } from 'lib/contacts'

const bmsTplLabels = {
  content: { subTitle: '', title: '내용' },
  imageLink: { subTitle: '', title: '이미지 클릭 링크' },
  additionalContent: { subTitle: '', title: '추가 내용' },
  header: { subTitle: '', title: '헤더' },
  'carousel.head.header': { subTitle: '메인 캐러셀', title: '헤더' },
  'carousel.head.content': { subTitle: '메인 캐러셀', title: '내용' },
  'carousel.head.linkPc': { subTitle: '메인 캐러셀', title: 'PC 웹링크' },
  'carousel.head.linkMobile': {
    subTitle: '메인 캐러셀',
    title: '모바일 웹링크'
  },
  'carousel.head.linkAndroid': {
    subTitle: '메인 캐러셀',
    title: '안드로이드 URL 스킴'
  },
  'carousel.head.linkIos': { subTitle: '메인 캐러셀', title: 'IOS URL 스킴' },
  'carousel.list.header': { subTitle: '캐러셀 리스트', title: '헤더' },
  'carousel.list.content': { subTitle: '캐러셀 리스트', title: '내용' },
  'carousel.list.additionalContent': {
    subTitle: '캐러셀 리스트',
    title: '추가 내용'
  },
  'carousel.list.imageLink': {
    subTitle: '캐러셀 리스트',
    title: '이미지 클릭 링크'
  },
  'carousel.list.commerce.title': {
    subTitle: '캐러셀 리스트 상품',
    title: '상품명'
  },
  'carousel.list.commerce.regularPrice': {
    subTitle: '캐러셀 리스트 상품',
    title: '정가'
  },
  'carousel.list.commerce.discountPrice': {
    subTitle: '캐러셀 리스트 상품',
    title: '할인가'
  },
  'carousel.list.commerce.discountRate': {
    subTitle: '캐러셀 리스트 상품',
    title: '할인율'
  },
  'carousel.list.commerce.discountFixed': {
    subTitle: '캐러셀 리스트 상품',
    title: '할인금액'
  },
  'carousel.list.buttons.name': {
    subTitle: '캐러셀 리스트 버튼',
    title: '버튼명'
  },
  'carousel.list.buttons.linkType': {
    subTitle: '캐러셀 리스트 버튼',
    title: '링크 타입'
  },
  'carousel.list.buttons.linkMobile': {
    subTitle: '캐러셀 리스트 버튼',
    title: '모바일 웹링크'
  },
  'carousel.list.buttons.linkPc': {
    subTitle: '캐러셀 리스트 버튼',
    title: 'PC 웹링크'
  },
  'carousel.list.buttons.linkAndroid': {
    subTitle: '캐러셀 리스트 버튼',
    title: '안드로이드 URL 스킴'
  },
  'carousel.list.buttons.linkIos': {
    subTitle: '캐러셀 리스트 버튼',
    title: 'IOS URL 스킴'
  },
  'carousel.list.coupon.title': {
    subTitle: '캐러셀 리스트 쿠폰',
    title: '쿠폰명'
  },
  'carousel.list.coupon.description': {
    subTitle: '캐러셀 리스트 쿠폰',
    title: '쿠폰 설명'
  },
  'carousel.list.coupon.linkMobile': {
    subTitle: '캐러셀 리스트 쿠폰',
    title: '모바일 웹링크'
  },
  'carousel.list.coupon.linkPc': {
    subTitle: '캐러셀 리스트 쿠폰',
    title: 'PC 웹링크'
  },
  'carousel.list.coupon.linkAndroid': {
    subTitle: '캐러셀 리스트 쿠폰',
    title: '안드로이드 URL 스킴'
  },
  'carousel.list.coupon.linkIos': {
    subTitle: '캐러셀 리스트 쿠폰',
    title: 'IOS URL 스킴'
  },
  'carousel.tail.linkPc': { subTitle: '더보기', title: 'PC 웹링크' },
  'carousel.tail.linkMobile': {
    subTitle: '더보기',
    title: '모바일 웹링크'
  },
  'carousel.tail.linkAndroid': {
    subTitle: '더보기',
    title: '안드로이드 URL 스킴'
  },
  'carousel.tail.linkIos': { subTitle: '더보기', title: 'IOS URL 스킴' },
  'mainWideItem.title': { subTitle: '메인 와이드 아이템', title: '제목' },
  'mainWideItem.linkMobile': {
    subTitle: '메인 와이드 아이템',
    title: '모바일 웹링크'
  },
  'mainWideItem.linkPc': { subTitle: '메인 와이드 아이템', title: 'PC 웹링크' },
  'mainWideItem.linkAndroid': {
    subTitle: '메인 와이드 아이템',
    title: '안드로이드 URL 스킴'
  },
  'mainWideItem.linkIos': {
    subTitle: '메인 와이드 아이템',
    title: 'IOS URL 스킴'
  },
  'subWideItemList.title': { subTitle: '서브 와이드 아이템', title: '제목' },
  'subWideItemList.linkMobile': {
    subTitle: '서브 와이드 아이템',
    title: '모바일 웹링크'
  },
  'subWideItemList.linkPc': {
    subTitle: '서브 와이드 아이템',
    title: 'PC 웹링크'
  },
  'subWideItemList.linkAndroid': {
    subTitle: '서브 와이드 아이템',
    title: '안드로이드 URL 스킴'
  },
  'subWideItemList.linkIos': {
    subTitle: '서브 와이드 아이템',
    title: 'IOS URL 스킴'
  },
  'commerce.title': { subTitle: '상품', title: '상품명' },
  'commerce.regularPrice': { subTitle: '상품', title: '정가' },
  'commerce.discountPrice': { subTitle: '상품', title: '할인가' },
  'commerce.discountRate': { subTitle: '상품', title: '할인율' },
  'commerce.discountFixed': { subTitle: '상품', title: '할인금액' },
  'buttons.name': { subTitle: '버튼', title: '버튼명' },
  'buttons.linkType': { subTitle: '버튼', title: '링크 타입' },
  'buttons.linkMobile': { subTitle: '버튼', title: '모바일 웹링크' },
  'buttons.linkPc': { subTitle: '버튼', title: 'PC 웹링크' },
  'buttons.linkAndroid': { subTitle: '버튼', title: '안드로이드 URL 스킴' },
  'buttons.linkIos': { subTitle: '버튼', title: 'IOS URL 스킴' },
  'coupon.title': { subTitle: '쿠폰', title: '쿠폰명' },
  'coupon.description': { subTitle: '쿠폰', title: '쿠폰 설명' },
  'coupon.linkMobile': { subTitle: '쿠폰', title: '모바일 웹링크' }
}

export default function getBmsTplVariables(tpl, parentKey = '') {
  const result = []
  if (isString(tpl) && !isEmptyString(parentKey)) {
    const index = parentKey
      .split('.')
      .filter(data => isNumberString(data))
      .pop()
    const labelKeyName = parentKey
      .split('.')
      .filter(data => !isNumberString(data))
      .join('.')
    const label = get(bmsTplLabels, labelKeyName)
    const fieldName =
      label?.subTitle +
      (isNumberString(index) ? ` ${Number(index) + 1}번째 -` : '') +
      ' ' +
      label?.title
    const vars = getExtraFieldFromText(tpl, parentKey, fieldName, {
      bmsFlag: true,
      checkInvalid: true
    })
    result.push(...vars)
  }
  if (isArray(tpl) && !isEmptyString(parentKey)) {
    tpl.forEach((item, index) => {
      const res = getBmsTplVariables(item, `${parentKey}.${index}`)
      result.push(...res)
    })
  }
  if (isObject(tpl)) {
    Object.keys(tpl).forEach(keyName => {
      const res = getBmsTplVariables(
        tpl[keyName],
        !isEmptyString(parentKey) ? `${parentKey}.${keyName}` : keyName
      )
      result.push(...res)
    })
  }
  return result
}
